export const BASE_URL = 'https://d2vluxb694imb6.cloudfront.net/dev/maruti';
export const environment = {
  production: false,
  baseUrl: `${BASE_URL}/communication-service/v1/`,
  FORM_BASE_URL: `${BASE_URL}/form/v1/`,
  PLACEHOLDER_URL: `${BASE_URL}/form-lambda/v1/placeholder`,
  composite: `${BASE_URL}/composite/v1/`,
};
